/**
 * Выбранная студия суперадмина в приложении тренера.
 * Хранится на устройстве и уходит в запросы заголовком `X-Impersonate-Organization-Id`
 * (так же, как в staff SPA). Показывается только для тренерской сессии.
 */
const STORAGE_KEY = 'domcrm_embed_superadmin_org_id';
const GLOBAL_SESSION_KEY = 'domcrm_embed_global_session';

function readSessionMode(): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(GLOBAL_SESSION_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as { embedMode?: unknown };
    return typeof o.embedMode === 'string' ? o.embedMode : null;
  } catch {
    return null;
  }
}

export function getSuperadminOrgId(): number | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setSuperadminOrgId(organizationId: number | null): void {
  if (typeof localStorage === 'undefined') return;
  if (organizationId == null || organizationId <= 0) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, String(organizationId));
}

export function clearSuperadminOrgId(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}

/** Заголовок выбора студии имеет смысл только в тренерской сессии (не в клиентском виджете). */
export function shouldSendSuperadminOrgHeader(): boolean {
  return readSessionMode() === 'trainer';
}
